import React, { useState } from 'react'
import { Query } from 'react-apollo'
import InfiniteScroll from 'react-infinite-scroller'
import Lightbox from 'react-images'
import { Div, Icon, LoadingIcon } from 'konsys-ui'
import { SHOW_GALLERY } from '../../constants/graph/query'
import Container from '../../components/container'
import { WidthContainer } from '../../components/container/styled'
import Banner from '../../images/gallery/Galley_Banner.jpg'
import { theme } from '../../styles/_variables'
import {
  ImageWrapper, ImgBg,
} from './styled'

const Image = ({ img, onClick }) => (
  <ImageWrapper onClick={() => onClick()}>
    <ImgBg img={img} />
    <Icon icon='far fa-search-plus' />
  </ImageWrapper>
)

const GalleryContainer = () => {
  const [openLightBox, setOpenLightBox] = useState(false)
  const [currentImage, setCurrentImage] = useState(0)
  const limit = 6


  return (
    <Container
      header={{
        type: 'title',
        img: Banner,
        title: 'ผลงานของเรา',
        color: theme.color.offWhite,
      }}
      backgroundColor={theme.color.offWhite}
    >
      <Query
        query={SHOW_GALLERY}
        variables={{
          limit,
          offset: 0,
        }}
      >
      {
        ({ loading, data, fetchMore }) => {
          if (loading) return <Div margin='24px 0' textAlign='center'><LoadingIcon color={theme.color.grey} /></Div>
          if (!data.showGallery.success) return <p>error something</p>
          const galleryData = data.showGallery.gallery
          return (
            <WidthContainer>
              <InfiniteScroll
                initialLoad={false}
                loadMore={() => {
                  fetchMore({
                    variables: {
                      limit,
                      offset: data.showGallery.gallery.length,
                    },
                    updateQuery: (prev, { fetchMoreResult }) => {
                      if (!fetchMoreResult.showGallery.success) return prev
                      return Object.assign({}, prev, {
                        showGallery: {
                          ...prev.showGallery,
                          gallery: [...prev.showGallery.gallery, ...fetchMoreResult.showGallery.gallery],
                        },
                      })
                    },
                  })
                }}
                pageStart={0}
                hasMore={data.showGallery.gallery.length !== data.showGallery.count}
                loader={<Div margin='0 0 24px'><LoadingIcon fullWidth center /></Div>}
              >
              <Div key='test' margin='44px -12px' display='flex' moreStyle={{ flexWrap: 'wrap' }}>
              {
                galleryData.map((v, i) => (
                  <Image
                    key={v.galleryId}
                    img={v.galleryFileUri}
                    onClick={() => {
                      setCurrentImage(i)
                      setOpenLightBox(true)
                    }}
                  />
                ))
              }
              </Div>
              </InfiniteScroll>
            </WidthContainer>
          )
        }
      }
      </Query>
      <Query
        query={SHOW_GALLERY}
        variables={{
          limit: 10000,
          offset: 0,
        }}
      >
      {
        ({ loading, data }) => {
          if (loading) return null
          if (!data.showGallery.success) return <p>error something</p>
          const galleryData = data.showGallery.gallery
          return (
            <Lightbox
              images={galleryData.map(v => (
                { src: v.galleryFileUri }
              ))}
              currentImage={currentImage}
              isOpen={openLightBox}
              onClickNext={() => setCurrentImage(currentImage + 1)}
              onClickPrev={() => setCurrentImage(currentImage - 1)}
              onClose={() => setOpenLightBox(false)}
              backdropClosesModal={true}
            />
          )
        }
      }
      </Query>
    </Container>
  )
}

export default GalleryContainer



// WEBPACK FOOTER //
// ./src/pages/gallery/index.jsx